import axios from 'axios';
import { integer, max, min_value } from '@vee-validate/rules';
import { defineRule } from 'vee-validate';

defineRule('existing-barcode', (value, { isExistingBarcode }) =>
    isExistingBarcode(value) || 'Barcode does not match any existing product.');

export default {
    data() {
        return {
            existingBarcodes: [],
            stockOnHandConfiguration: {
                type: 'stockOnHand',
                label: 'Stock On Hand',
                sampleNotes: ['Any Code fields left blank will be generated.'],
                importNotes: this.getImportNotes,
                fields: [
                    {
                        key: 'Location',
                        label: 'Location',
                        hasErrorCalculator: value => {
                            return (
                                value == '' ||
                                value == undefined ||
                                min_value(value, { min: 0 }) !== true
                            );
                        },
                        rules: 'required|min_value:0',
                        samples: ['"North Campus"', '"City Campus"'],
                        dataType: 'locations'
                    },
                    {
                        key: 'Barcode',
                        label: 'Barcode',
                        hasErrorCalculator: value => {
                            if (this.isEmpty(value)) {
                                return true;
                            }
                            if (max(value, { length: 128 }) !== true) {
                                return true;
                            }
                            return !this.isExistingBarcode(value);
                        },
                        rules: {
                            required: true,
                            max: { length: 128 },
                            'existing-barcode': {
                                isExistingBarcode: this.isExistingBarcode
                            }
                        },
                        samples: ['"2235467890161"','"1135467890171"']
                    },
                    {
                        key: 'Action',
                        label: 'Action',
                        hasErrorCalculator: value => {
                            return !this.matchesExistingObject(value, true);
                        },
                        rules: 'required|min_value:0',
                        dataType: 'addReplaceOptions',
                        samples: ['"Add"', '"Replace"']
                    },
                    {
                        key: 'AdjustmentQuantity',
                        label: 'Adjustment Quantity',
                        hasErrorCalculator: value => {
                            if (this.isEmpty(value)) {
                                return true;
                            }
                            return integer(value) !== true;
                        },
                        rules: "required",
                        samples: [1, 5, 10, 15],
                        convertToNumber: true
                    },
                    {
                        key: 'Comment',
                        label: 'Comment',
                        hasErrorCalculator: value => {
                            return max(value, { length: 2000 }) !== true;
                        },
                        rules: 'max:2000',
                        samples: ['""', '""']
                    }
                ]
            }
        };
    },
    methods: {
        isExistingBarcode(value) {
            if (this.isEmpty(value)) {
                return false;
            }
            return this.existingBarcodes.includes(value + '');
        },
        async getImportNotes(){
            var codes = this.loadedData.map(x => x.Barcode);
            let notFoundProductBarcodes = (await axios.post('imports/barcodesnotfound', { barcodes: codes })).data;
            let notes = []
            if(notFoundProductBarcodes.length > 0){
                notes.push(`Following product barcodes that are not found will be skipped on import: ${notFoundProductBarcodes.join(', ')}`  )
            }

            return notes;
        }
    }
};
